import Games from "./games";

export default Games;
